export default "__VITE_ASSET__DIMLwuHo__"